import { Injectable } from "@angular/core";
import { NavigationService } from "@apps/patient-core/src/app/services/navigation.service";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";

@Injectable({
  providedIn: "root",
})
export class JwtResolver {
  constructor(private _navigationService: NavigationService, private _authService: BaseAuthService) {}

  public resolve(): boolean {
    if (this._authService.isRestricted) {
      this._navigationService.navigate("/restricted/access");
      return false;
    }

    const jwtData = this._authService.getJWT();

    if (jwtData && this._authService.isPatient()) {
      this._navigationService.navigate("/my-dental");
      return true;
    }

    if (jwtData && jwtData.practice_id) return jwtData;

    return false;
  }
}
